import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { Select, MenuItem, InputLabel } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import OccurrenceFilterControl from "./OccurrenceFilterControl";
import OccurrenceTypeOption from "./OccurrenceTypeOption";

export const ALL_REASONS_ID = "0-0";
const ALL_GROUPS_ID = "0";

export default function OccurrenceTypeFilters({
  groups,
  selectedGroup,
  groupLocked,
  reasonsHidden,
  reasonId,
  onGroupChange,
  onReasonChange
}) {
  const { t } = useTranslation();
  const allLabel = t("common.actions.all");

  const groupOptions = useMemo(
    () => [{ id: ALL_GROUPS_ID, name: allLabel }, ...groups],
    [allLabel, groups]
  );

  const groupReasons = useMemo(
    () =>
      selectedGroup && Array.isArray(selectedGroup.reasons)
        ? selectedGroup.reasons
        : [],
    [selectedGroup]
  );

  const reasonOptions = useMemo(
    () => [{ id: ALL_REASONS_ID, name: allLabel }, ...groupReasons],
    [allLabel, groupReasons]
  );

  const renderGroup = group =>
    group.id === ALL_GROUPS_ID ? (
      group.name
    ) : (
      <OccurrenceTypeOption occurrence={group} />
    );

  return (
    <>
      {!groupLocked && (
        <OccurrenceFilterControl>
          <InputLabel id="occurrence-group-label">
            {t("occurrences.student.groups")}
          </InputLabel>
          <Select
            labelId="occurrence-group-label"
            label={t("occurrences.student.groups")}
            value={selectedGroup || groupOptions[0]}
            onChange={e =>
              onGroupChange(
                e.target.value.id === ALL_GROUPS_ID ? null : e.target.value
              )}
            renderValue={renderGroup}
          >
            {groupOptions.map(group => (
              <MenuItem key={group.id} value={group}>
                {renderGroup(group)}
              </MenuItem>
            ))}
          </Select>
        </OccurrenceFilterControl>
      )}
      {!reasonsHidden && (
        <OccurrenceFilterControl disabled={!groupReasons.length}>
          <InputLabel id="occurrence-reason-label">
            {t("occurrences.student.types")}
          </InputLabel>
          <Select
            labelId="occurrence-reason-label"
            label={t("occurrences.student.types")}
            value={reasonId}
            onChange={e => onReasonChange(e.target.value)}
          >
            {reasonOptions.map(reason => (
              <MenuItem key={reason.id} value={reason.id}>
                <OccurrenceTypeOption
                  occurrence={{
                    ...reason,
                    nivel:
                      reason.nivel || (selectedGroup && selectedGroup.nivel)
                  }}
                />
              </MenuItem>
            ))}
          </Select>
        </OccurrenceFilterControl>
      )}
    </>
  );
}

OccurrenceTypeFilters.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  selectedGroup: PropTypes.shape({
    reasons: PropTypes.arrayOf(PropTypes.shape()),
    nivel: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  groupLocked: PropTypes.bool,
  reasonsHidden: PropTypes.bool,
  reasonId: PropTypes.string.isRequired,
  onGroupChange: PropTypes.func.isRequired,
  onReasonChange: PropTypes.func.isRequired
};

OccurrenceTypeFilters.defaultProps = {
  selectedGroup: null,
  groupLocked: false,
  reasonsHidden: false
};
